import { rootApi } from "../../api/rootApi";

// ── Old firebase_config endpoints (kept for backward compat) ─────────────────
export const tenantFirebaseSetupApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllFirebaseSetup: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/firebase`,
        headers: { Authorization: "Bearer " + params.token },
      }),
    }),
    addFirebaseSetup: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/admin/firebase/add`,
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + params.token },
        body: JSON.stringify(params.body),
      }),
    }),
    updateFirebaseSetup: builder.mutation({
      query: (params) => ({
        method: "PUT",
        url: `/admin/firebase/${params.id}`,
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + params.token },
        body: params.data,
      }),
    }),
    removeFirebaseSetupById: builder.mutation({
      query: (params) => ({
        method: "DELETE",
        url: `/admin/firebase/${params.id}`,
        headers: { Authorization: "Bearer " + params.token },
      }),
    }),

    // ── firebase_project_connections endpoints ───────────────────────────────
    getFirebaseConnections: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/firebase-connections?limit=${params.limit}&offset=${params.offset}${params.search ? `&search=${encodeURIComponent(params.search)}` : ""}`,
        headers: { Authorization: "Bearer " + params.token },
      }),
    }),
    addFirebaseConnection: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/admin/firebase-connections`,
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + params.token },
        body: JSON.stringify(params.body),
      }),
    }),
    updateFirebaseConnection: builder.mutation({
      query: (params) => ({
        method: "PUT",
        url: `/admin/firebase-connections/${params.id}`,
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + params.token },
        body: JSON.stringify(params.body),
      }),
    }),
    deleteFirebaseConnection: builder.mutation({
      query: (params) => ({
        method: "DELETE",
        url: `/admin/firebase-connections/${params.id}`,
        headers: { Authorization: "Bearer " + params.token },
      }),
    }),
  }),
});

export const {
  useGetAllFirebaseSetupMutation,
  useAddFirebaseSetupMutation,
  useUpdateFirebaseSetupMutation,
  useRemoveFirebaseSetupByIdMutation,
  useGetFirebaseConnectionsMutation,
  useAddFirebaseConnectionMutation,
  useUpdateFirebaseConnectionMutation,
  useDeleteFirebaseConnectionMutation,
} = tenantFirebaseSetupApi;
